export const GET_USERS = "GET_USERS";
export const USER_LOGGED = "USER_LOGGED";
export const GET_POSTS = "GET_POSTS";
export const POST_POSTS = "POST_POSTS";
export const SEARCH_BY_ID = "SEARCH_BY_ID";
export const CLEAR_STATE = "CLEAR_STATE";
export const POST_COMMENT = "POST_COMMENT";
export const SEARCH_TAG = "SEARCH_TAG";
export const ALL_LIKES = "ALL_LIKES";
export const ALL_DISLIKES = "ALL_DISLIKES";
export const LIKE = "LIKE";
export const DISLIKE = "DISLIKE";
export const DISLIKE_UP = "DISLIKE_UP";
export const DISLIKE_DOWN = "DISLIKE_DOWN";
export const GET_FEEDPOSTS = "GET_FEEDPOSTS";
export const FILTER_LIKES_FORO = "FILTER_LIKES_FORO";
export const FILTER_COMMENTS_FORO = "FILTER_COMMENTS_FORO";
export const FILTER_DATE_FORO = "FILTER_DATE_FORO";
export const POST_FEEDPOSTS = "POST_FEEDPOSTS";
export const FEEDCOMMENTS = "FEEDCOMMENTS";
export const GETLIKES = "GETLIKES";
export const GETDISLIKES = "GETDISLIKES";
export const FEEDLIKES = "FEEDLIKES";
export const FEEDDISLIKES = "FEEDPOSTS";
export const POST_FEEDCOMMENTS = "POST_FEEDCOMMENTS";
export const FILTER_FEED_POSTS = "FILTER_FEED_POSTS";
export const GET_POSTSRECIENTES = "GET_POSTSRECIENTES";
export const SEARCH_FEEDPOST_ID = "SEARCH_FEEDPOST_ID";
export const PUT_PROFILE = "PUT_PROFILE";